module.exports = __webpack_public_path__ + "img/close-up-female-hand-using-digital-tablet-tablet@2x.d9a14825.png";